import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { countryOptions } from '@erp/shared';
import { CatalogueSelect } from './catalogue-select';

type CountrySelectProps = {
  id?: string | undefined;
  label?: string | undefined;
  value: string | null | undefined;
  onChange: (value: string) => void;
  allowedCodes?: readonly string[];
  clearable?: boolean;
  disabled?: boolean;
  emptyValueLabel?: string | undefined;
};
export function CountrySelect({
  value,
  label,
  allowedCodes,
  onChange,
  ...props
}: CountrySelectProps): JSX.Element {
  const { t, i18n } = useTranslation();
  const options = useMemo(
    () => countryOptions(i18n.language, allowedCodes),
    [i18n.language, allowedCodes],
  );
  return (
    <CatalogueSelect
      {...props}
      label={label ?? t('international.country')}
      value={value ?? ''}
      options={options}
      onChange={(values) => onChange(values[0] ?? '')}
    />
  );
}
export function CountryMultiSelect({
  value,
  onChange,
  id,
  label,
}: {
  id?: string;
  label?: string;
  value: readonly string[];
  onChange: (value: string[]) => void;
}): JSX.Element {
  const { t, i18n } = useTranslation();
  const options = useMemo(() => countryOptions(i18n.language), [i18n.language]);
  return (
    <CatalogueSelect
      id={id}
      label={label ?? t('international.country')}
      value={value}
      options={options}
      multiple
      onChange={onChange}
      emptyValueLabel={t('international.allCountries')}
    />
  );
}
